module.exports = __webpack_public_path__ + "static/media/img_Benchmarking406.53df3290.png";